// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/careerPage/careerPeople_Bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageContainering {
  padding: 0;
  background-color: #1d1a36;
}

.image-bg-image {
  height: 100vh;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 600px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media (max-width: 550px) {
  .image-bg-image {
    margin-top: 55vw;
  }
}

.imageRow1st {
  margin-top: -17%;
  background-color: #1d1a36;
}

.textNucleusteq {
  color: #FFF;
  padding: 2vh;
  text-align: center;
  font-family: Roboto;
  font-size: 1.5vw;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 60px;
  margin-top: 30px;
}

.imagesRow {
  width: 100%;
  position: absolute;
  bottom: 30vh;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #252525;
}

@media (max-width: 1200px) {
  .imagesRow {
    bottom: 27vh;
  }
  .textNucleusteq {
    font-size: 2vw;
  }
}
@media (max-width: 992px) {
  .imagesRow {
    bottom: 26vh;
  }
  .textNucleusteq {
    font-size: 2vw;
  }
}
@media (max-width: 768px) {
  .imagesRow {
    bottom: 25vh;
  }
  .imageRow1st {
    margin-top: -30%;
  }
  .textNucleusteq {
    font-size: 2.3vw;
  }
}
@media (max-width: 576px) {
  .imagesRow {
    bottom: 24vh;
  }
  .textNucleusteq {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ImageForLife/imageForLife.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,iBAAA;EACA,yDAAA;AACF;AACE;EATF;IAUI,gBAAA;EAEF;AACF;;AACA;EACE,gBAAA;EACA,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAEF;;AACA;EACE;IACE,YAAA;EAEF;EACA;IACE,cAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;EAAF;EAGA;IACE,cAAA;EADF;AACF;AAIA;EACE;IACE,YAAA;EAFF;EAKA;IACE,gBAAA;EAHF;EAMA;IACE,gBAAA;EAJF;AACF;AAOA;EACE;IACE,YAAA;EALF;EAQA;IACE,cAAA;EANF;AACF","sourcesContent":[".imageContainering {\n  padding: 0;\n  background-color: #1d1a36;\n}\n\n.image-bg-image {\n  height: 100vh;\n  position: relative;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  min-height: 600px;\n  background-image: url(\"../../assets/images/careerPage/careerPeople_Bg.webp\");\n\n  @media (max-width:550px){\n    margin-top: 55vw;\n  }\n}\n\n.imageRow1st {\n  margin-top: -17%;\n  background-color: #1d1a36;\n}\n\n.textNucleusteq {\n  color: #FFF;\n  padding: 2vh;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 1.5vw;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n  margin-bottom: 60px;\n  margin-top: 30px;\n}\n\n.imagesRow {\n  width: 100%;\n  position: absolute;\n  bottom: 30vh;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #252525;\n}\n\n@media (max-width: 1200px) {\n  .imagesRow {\n    bottom: 27vh;\n  }\n\n  .textNucleusteq {\n    font-size: 2vw;\n  }\n}\n\n@media (max-width: 992px) {\n  .imagesRow {\n    bottom: 26vh;\n  }\n\n  .textNucleusteq {\n    font-size: 2vw;\n  }\n}\n\n@media (max-width: 768px) {\n  .imagesRow {\n    bottom: 25vh;\n  }\n\n  .imageRow1st {\n    margin-top: -30%;\n  }\n\n  .textNucleusteq {\n    font-size: 2.3vw;\n  }\n}\n\n@media (max-width: 576px) {\n  .imagesRow {\n    bottom: 24vh;\n  }\n\n  .textNucleusteq {\n    font-size: 4vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
